
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouter2Off as ObiRouter2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-2-off.js';
 
 
 

 
 export const ObiRouter2Off = createComponent({
   react: React,
   tagName: 'obi-router-2-off',
   elementClass: ObiRouter2OffElement,
   events: {
     
   }
  });
 
 